export const urls = {
	enable: '/rest/jpo/1.0/plans/enableMultiScenario',
	disable: '/rest/jpo/1.0/plans/disableMultiScenario',
	scenarios: '/rest/jpo/1.0/scenarios',
	delete: '/rest/jpo/1.0/scenarios/delete',
	update: '/rest/jpo/1.0/scenarios/update',
} as const;
